import * as React from "react";
import { Box, type BoxProps } from "../../components/ui/box";

/**
 * dnd-kit's Mouse/Touch drag sensors (see `sortable-grid`) begin a drag on the
 * `mousedown` / `touchstart` that bubbles up to the card. `WidgetInteractive`
 * swallows those two at its boundary so a press that lands inside it acts on
 * the content — selects, clicks, drills in — instead of grabbing the card. It
 * only stops those press-start events: the click itself rides `pointer-up`
 * (untouched, so `onClick` still fires) and hover is CSS (untouched, so a
 * `hoverBackground` wash still appears).
 *
 * Wrap it around the interactive island of a {@link WidgetModule} that opts
 * into `bodyDraggable` — e.g. a metric's one tappable number sitting in an
 * otherwise-grabbable card. It forwards every {@link BoxProps}, so give it
 * `onClick`, `hoverBackground`, padding, `rounded`, `cursor`, etc. to make the
 * island a self-contained hit target.
 */
export function WidgetInteractive({ children, ...boxProps }: BoxProps) {
  const swallow = React.useCallback(
    (event: { stopPropagation: () => void }) => event.stopPropagation(),
    [],
  );
  return (
    <Box {...boxProps} onMouseDown={swallow} onTouchStart={swallow}>
      {children}
    </Box>
  );
}
